var conditionCarousel = {
  init: function() {
    $('.js-condition-carousel').each(function (index, element) {
      var $carousel = $(element);
      var slideCount = $carousel.find('.gallery-cell').length;
      
      if (slideCount <= 1) {
        return;
      }

      var cellAlign = 'left';
      var draggable = true;
      var prevNext = true;
      var wrapAround = false;
      var freeScroll = false;
      var contain = true;
      var pageDots = false;

      if (!$carousel.hasClass('flickity-enabled')) {
        $carousel.flickity({
          cellAlign: cellAlign,
          contain: contain,
          draggable: draggable,
          freeScroll: freeScroll,
          imagesLoaded: true,
          pageDots: pageDots,
          prevNextButtons: false,
          wrapAround: wrapAround,
          selectedAttraction: 0.025,
          friction: 0.28
        });

        $carousel.addClass('condition-carousel-initialized');
        $carousel.closest('.condition-carousel').addClass('initialized');

        var $section = $carousel.closest('.condition-carousel');
        var $prevButton = $section.find('.condition-carousel__nav-button--prev');
        var $nextButton = $section.find('.condition-carousel__nav-button--next');
        var $navContainer = $section.find('.condition-carousel__nav');

        function checkNavigationNeeded() {
          var flkty = $carousel.data('flickity');
          if (!flkty) return;
          
          var visibleSlides = Math.floor($carousel.width() / ($carousel.find('.gallery-cell').first().outerWidth() + 20));
          var needsNavigation = slideCount > visibleSlides;
          
          if (needsNavigation) {
            $navContainer.show();
          } else {
            $navContainer.hide();
          }
        }

        $prevButton.off('click');
        $nextButton.off('click');

        $prevButton.on('click', function(e) {
          e.preventDefault();
          $carousel.flickity('previous');
        });

        $nextButton.on('click', function(e) {
          e.preventDefault();
          $carousel.flickity('next');
        });

        function updateButtonStates() {
          var flkty = $carousel.data('flickity');
          if (!flkty) return;
          
          var slideWidth = $carousel.find('.gallery-cell').first().outerWidth() + 20;
          var visibleSlides = Math.floor($carousel.width() / slideWidth);
          
          var maxIndex = Math.max(0, flkty.slides.length - visibleSlides);
          
          if (visibleSlides <= 3) {
            maxIndex = Math.max(0, maxIndex - 1);
          }
          
          if (flkty.selectedIndex === 0) {
            $prevButton.prop('disabled', true);
          } else {
            $prevButton.prop('disabled', false);
          }
          
          var canScrollNext = flkty.selectedIndex < maxIndex;
          
          if (canScrollNext) {
            $nextButton.prop('disabled', false);
          } else {
            $nextButton.prop('disabled', true);
          }
        }
        
        $carousel.off('select.conditionCarousel settle.conditionCarousel')
                .on('select.conditionCarousel', function() {
                  // Remove any aria-selected attributes that Flickity might add
                  $carousel.find('.gallery-cell').removeAttr('aria-selected');
                  
                  updateButtonStates();
                  checkNavigationNeeded();
                })
                .on('settle.conditionCarousel', function() {
                  // Remove any aria-selected attributes that Flickity might add
                  $carousel.find('.gallery-cell').removeAttr('aria-selected');
                  
                  updateButtonStates();
                });

        $carousel.trigger('select.flickity');
        checkNavigationNeeded();

        var resizeTimeout;
        $(window).off('resize.conditionCarousel').on('resize.conditionCarousel', function() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(function() {
            if ($carousel.hasClass('flickity-enabled')) {
              $carousel.flickity('destroy');
              conditionCarousel.init();
            }
          }, 300);
        });
      }
    });
  },

  unload: function($target) {
    var $carousel = $target.find('.js-condition-carousel');
    if ($carousel.hasClass('flickity-enabled')) {
      $carousel.flickity('destroy');
    }
  }
};

$(document).ready(function() {
  conditionCarousel.init();
});

$(document).on('shopify:section:load', function(event) {
  conditionCarousel.init();
});

$(document).on('shopify:section:unload', function(event) {
  conditionCarousel.unload($(event.target));
});
